// 画像パターンを作成して描画する汎用関数（Promise版）
export const drawWithImagePattern = (
  ctx: CanvasRenderingContext2D,
  imagePath: string,
  drawFunction: () => void,
  fallbackColor: string,
  patternSizeRatio = 2.2,
  isFlippedHorizontally = false
): Promise<void> => {
  return new Promise((resolve) => {
    const img = new Image()

    img.onload = () => {
      // 小さなCanvasを作成してリピート単位のサイズを調整
      const tempCanvas = document.createElement('canvas')
      const tempCtx = tempCanvas.getContext('2d')
      if (!tempCtx) {
        ctx.fillStyle = fallbackColor
        drawFunction()
        resolve()
        return
      }

      // リピート単位のサイズを調整
      const patternSize = Math.min(img.width, img.height) / patternSizeRatio
      tempCanvas.width = patternSize
      tempCanvas.height = patternSize

      // 高品質な縮小を設定
      tempCtx.imageSmoothingEnabled = true
      tempCtx.imageSmoothingQuality = 'high'

      // 水平反転が指定されている場合、変換を適用
      if (isFlippedHorizontally) {
        tempCtx.save()
        tempCtx.scale(-1, 1)
        tempCtx.drawImage(img, -tempCanvas.width, 0, tempCanvas.width, tempCanvas.height)
        tempCtx.restore()
      } else {
        tempCtx.drawImage(img, 0, 0, tempCanvas.width, tempCanvas.height)
      }

      const pattern = ctx.createPattern(tempCanvas, 'repeat')
      if (pattern) {
        ctx.fillStyle = pattern
      } else {
        ctx.fillStyle = fallbackColor
      }

      drawFunction()
      resolve()
    }

    img.onerror = () => {
      // 画像読み込み失敗時のフォールバック
      ctx.fillStyle = fallbackColor
      drawFunction()
      resolve()
    }

    img.src = imagePath
  })
}

export const drawWithImagePatternWrapper = async (
  ctx: CanvasRenderingContext2D,
  printLeatherTypeValue: string,
  drawPath: () => void,
  fallbackColor: string,
  patternSizeRatio = 2.2,
  isFlippedHorizontally = false
): Promise<void> => {
  if (printLeatherTypeValue && ['unselected', 'none', undefined].includes(printLeatherTypeValue)) {
    ctx.fillStyle = fallbackColor
    drawPath()
  } else {
    await drawWithImagePattern(
      ctx,
      `/atoms/leatherPrintings/${printLeatherTypeValue}.jpg`,
      drawPath,
      fallbackColor,
      patternSizeRatio,
      isFlippedHorizontally
    )
  }
}
